import { render, staticRenderFns } from "./payment-order-detail-card.vue?vue&type=template&id=1c567a35&"
import script from "./payment-order-detail-card.vue?vue&type=script&lang=js&"
export * from "./payment-order-detail-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports